import * as axios from "./axios";
const env ={
  ...axios,
}
export { env };
export { api } from "./api";
